import { useNavigate } from "react-router-dom";
import { PageHeader, Tag } from "../../components/ui";
import { notifications } from "../../fixtures/data";
export function NotificationsPage() {
  const nav = useNavigate();
  return (
    <div className="page">
      <PageHeader
        back={() => nav(-1)}
        eyebrow="ACTIVITY"
        title="Notifications"
      />
      <div className="notification-list">
        {notifications.map((n) => (
          <button
            key={n.id}
            onClick={() => n.deepLink && nav(n.deepLink)}
            className={!n.read ? "unread" : ""}
          >
            <span className="notification-dot" />
            <div>
              <div className="row row--between">
                <strong>{n.title}</strong>
                {!n.read && <Tag tone="accent">New</Tag>}
              </div>
              <p>{n.body}</p>
              <small>
                {new Intl.RelativeTimeFormat("en", { numeric: "auto" }).format(
                  -Math.max(
                    1,
                    Math.round(
                      (Date.now() - new Date(n.createdAt).getTime()) / 3600000,
                    ),
                  ),
                  "hour",
                )}
              </small>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
